

















































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import AuthService from "../services/auth-service";
import StarRating from "vue-star-rating";
import "../styles/Videos.scss";
import moment from "moment";
import * as franc from "franc";
import VideoQuiz from "./VideoQuiz.vue";

declare var amp: any;
declare var AppInsightsUtils: any;
declare const InstallTrigger: any;
declare const window: any;

@Component({
  components: {
    "star-rating": StarRating,
    "video-quiz": VideoQuiz,
  },
  props: ["topicid", "topiclimit", "contentIds", "IsArvo", "referenceValue"],
})
export default class VideoLearning extends Vue {
  private service = new GeneralService();
  private level_id;
  private auth = new AuthService();
  starSize: number = 20;
  private topiclimit: number;
  private ifQuestionExists = false;
  private teacherID = "";
  private subjectID = "";
  private teacherName = "";
  private totalTime = 0;
  private prevStartTime = 0;
  private lastUpdatedTime = 0;
  private ended = false;
  private enableQuiz = false;
  private startSeek = 0;
  private stopSeek = 0;
  private totalSeek = 0;
  private maxWatched = 0;
  private ratingPrevId = "";
  private isSmart = false;
  private isVideoQuiz = false;
  private sentQuestion = false;
  private totalTimeWatched = 0;
  private checkingTopicId = '';

  private startError = false;
  private errorMessageVideo = "";
  private lastTime = 0;

  private iframeHtml = '';

  private showTime() {
    this.prevStartTime = this.player.currentAbsoluteTime();
  }

  private pauseTime() {
    this.totalTime +=
      this.player.currentAbsoluteTime() - this.prevStartTime;
  }

  private progressClicked() {
    this.lastUpdatedTime = this.player.player_.mediaPlayer.currentAbsoluteTime;
  }

  private videoCompleted() {
    this.ended = true;
  }

  // private checkQuiz(id) {
  //   if (this.enableQuiz){
  //     this.getVideoQuestions(id);
  //   } else {
  //     if (this.player)
  //       this.player.pause();
  //     this.$bvModal.show('quiz-locked');
  //   }
  // }

  private getVideoQuestions(id) {
    this.topicid = id;
    this.isVideoQuiz = true;
    this.player.pause();
    this.$bvModal.hide('quiz-unlocked');
  }

  private checkLang(str) {
    var lst = ["und", "urd", "fas", "pes", "skr", "arb", "uig"];
    var lan = franc(str, { minLength: 3 });

    return lst.indexOf(lan) > -1;
  }

  private seekingTime(seeked) {
    this.maxWatched = Math.max(
      this.maxWatched,
      this.player.currentAbsoluteTime()
    );
  }

  private seekedTime() {
    this.totaltime += this.lastUpdatedTime - this.prevStartTime;
    this.stopSeek = this.player.currentTime();

    if (Math.abs(this.stopSeek - this.startSeek) > 2) {
      this.totalSeek += this.stopSeek - this.startSeek;
    }

    this.startSeek = this.stopSeek;
  }

  private items = [
    {
      text: "Subjects",
      to: { name: "videosubject" },
    },
    {
      text: this.$store.state.selectSubjectName,
      href: "#",
    },
    {
      text: this.$store.state.selectSubjectName,
      href: "#",
    },
    {
      text: "Library",
      active: true,
    },
  ];

  private sourceLoaded = false;

  private entities: TopicsModel[] = [];
  private entity: TopicsModel = {
    topicId: "",
    chapterId: "",
    enableMcq: false,
    maxWatched: 0,
    tCode: "",
    fullName: "",
    description: "",
    videoLink: "",
    orderNumber: 0,
    isEnable: 0,
  };

  private question = "";
  private currentTopicId = "";
  private totaltime: number = 0;
  private previous: number = 0;
  private previousW: number = 0;
  private duration: number = 0;
  private actualW: number = 0;
  private srcToken: any;

  private firstTimeVideo = true;

  private ratingPrev = 0;

  private classSection = "";
  private sending = false;

  private parts: Array<Parts> = [];

  private chankParts: Array<Chank> = [];
  private totalChanks: number = 20;
  private chankStarted: boolean = false;

  private VsId: string = "";

  private rating: number = 0;
  private source: string = "";

  topicid: string;
  private player: any;

  private followUp = "";

  private timeInterval;
  private firstTime: boolean = true;

  private teacherData: any = [];

  private videoData() {
    const cIds = (this as any).contentIds || '';
    const refVal = (this as any).referenceValue || '';
    const isArvo = (this as any).IsArvo || false;
    const val = 'HADAF?' + cIds + '?Videos??' + refVal +
      '?' + this.$store.state.chapterSelectId +
      '?' + this.auth.session.userId + '?' + isArvo + '?false';
    this.service
      .getQuestionsWAnswersArvo(val)
      .then((result) => {
        if (result && result.length > 0) {
          for (let i = 0; i < this.entities.length; i++) {
            for (let j = 0; j < result.length; j++) {
              if (this.entities[i].topicId === result[j].topicId ||
                  this.entities[i].fullName === result[j].fullName) {
                this.entities[i].enableMcq = result[j].enableMcq;
                this.entities[i].maxWatched = result[j].maxWatched;
              }
            }
          }
        }
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  created() {

    this.level_id = localStorage[config.classLevl];
    this.VsId = localStorage["VsId"];

    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      router.push("select");
    }

    if (this.$route.query.type && this.$route.query.type == "smart") {
      this.isSmart = true;
    }
    if (!this.isSmart) {
      // New ARVO path: use contentIds + referenceValue passed as props from VideosTopic
      const contentType = 'Videos';
      const cIds = (this as any).contentIds || '';
      const refVal = (this as any).referenceValue || '';
      const isArvo = (this as any).IsArvo || false;
      const val = 'HADAF?' + cIds + '?' + contentType + '??' + refVal +
        '?' + this.$store.state.chapterSelectId +
        '?' + this.auth.session.userId + '?' + isArvo + '?false';
      this.service
        .getQuestionsWAnswersArvo(val)
        .then((result) => {
          // Strip HTML from fullName for clean sidebar display
          for (let item of result) {
            if (item.fullName) {
              const div = document.createElement('div');
              div.innerHTML = item.fullName;
              item.fullName = div.textContent || div.innerText || '';
            }
          }
          this.entities = result.splice(0, Math.min(result.length, this.topiclimit));
          if (this.entities !== undefined && this.entities.length > 0) {
            this.current(this.topicid);
            this.actualW = 0;
            this.duration = 0;
          }
        })
        .catch((err) => {
          console.error(`Error: ${err.message}`);
        });
    } else {
      const cIds = (this as any).contentIds || '';
      const refVal = (this as any).referenceValue || '';
      const programSelectString = localStorage[config.programSelect];
      const programSelectData = JSON.parse(programSelectString);
      const boardId = programSelectData.board.endsWith('s')
        ? programSelectData.board.slice(0, -1) : programSelectData.board;
      const classId = programSelectData.part.replace(/\s+/g, '');
      const val = this.auth.session.userId + '?' + this.level_id + '?' + boardId +
        '?' + this.$store.state.selectSubjectName + '?' + classId +
        '?' + this.$store.state.chapterSelectId + '?' + cIds + '?' + refVal;
      this.service
        .getarvosmartELVideoContent(val)
        .then((result) => {
          for (let item of result) {
            if (item.fullName) {
              const div = document.createElement('div');
              div.innerHTML = item.fullName;
              item.fullName = div.textContent || div.innerText || '';
            }
          }
          this.entities = result.splice(0, Math.min(result.length, this.topiclimit));
          if (this.entities !== undefined && this.entities.length > 0) {
            this.current(this.topicid);
            this.actualW = 0;
            this.duration = 0;
          }
        })
        .catch((err) => {
          console.error(`Error: ${err.message}`);
        });
    }
  }

  mounted() {
    AppInsightsUtils.setAuthNUserContext(
      this.auth.isAuthenticated(),
      this.auth.session.userName.split("@")[0]
    );
    setInterval(() => {
      if (this.player && this.player.error && this.player.error() == null && this.startError) {
        this.startError = false;
        this.player.currentTime(this.lastTime);
        this.errorMessageVideo = "";
      }
    }, 1000);

    this.service
      .getTeacherSubject(
        this.auth.session.userName.split("@")[0],
        localStorage[config.deviceId]
      )
      .then((result) => {
        this.teacherData = result.data.Data;

        for (const teacher of this.teacherData) {
          if (teacher.subject_Name == this.$store.state.selectSubjectName) {
            this.ifQuestionExists = true;
            this.teacherID = teacher.teacher_ID;
            this.subjectID = teacher.subject_ID;
            this.teacherName = teacher.teacher_Name;
          }
        }
      });

    this.service
      .getInfoEMS(this.auth.session.userName.split("@")[0])
      .then((result) => {
        this.classSection = result.data[0].Class_section_id;
      });
  }

  private setRating(rating) {
    this.service.ratingSave(this.currentTopicId + "?" + rating);
  }

  private setRatingPrev() {
    this.service
      .ratingSave(this.ratingPrevId + "?" + this.ratingPrev)
      .then((response) => {
        this.$bvModal.hide("rating");
      });
  }

  private sendData() {
    if (!this.player) return;
    let watchedTime = this.player.currentAbsoluteTime ? this.player.currentAbsoluteTime() : 0;
    let totalTime = this.player.duration ? this.player.duration() : 0;

    const jsonSend = {
      videoId: this.currentTopicId,
      videoName: this.$store.state.topicSelectName,
      username: this.auth.session.userName,
      finishedVideo: this.ended,
      systemEnvironment: navigator.userAgent,
      ip: localStorage[config.currentIpAddress],
      maxLengthWatched: Math.max(this.maxWatched, watchedTime),
      maxDuration: totalTime,
      sessionId: localStorage[config.sessionId],
      sessionTime: localStorage[config.sessionIdTime],
      dataTimeStamp: moment().unix(),
    };

    this.service.sendData(jsonSend).then((response) => console.log(response));
  }

  private goingAway(action: string) {
    debugger
    this.ratingPrev = 0;
    this.ratingPrevId = this.currentTopicId;

    if (action) {
      this.followUp = action;
    } else {
      this.followUp = "";
    }

    if (this.rating == 0) this.$bvModal.show("rating");
    else this.$emit("reset", action);
  }

  private modalClose() {
    if (this.followUp !== "videosubject") {
      this.$emit("reset", this.followUp);
    } else if (this.followUp == "videosubject")
      this.$router.push("videosubject");
  }

  private checkBrowser(src, calback) {
    let brow = "widevine";
    if (this.$browserDetect.isEdge || this.$browserDetect.isIE) {
      brow = "playReady";
    }
    if (this.$browserDetect.isSafari) {
      brow = "clear";
    }
    this.getToken(src, brow, (data) => {
      calback(data);
    });
  }

  // private checkState() {
  //   if (this.checkingTopicId !== this.topicid) {
  //     this.player.currentTime(0);
  //     this.totalSeek = 0;
  //     this.checkingTopicId = this.topicid;
  //   }
  //   if (this.player) {
  //     const timeWatched = this.player.currentTime() - this.totalSeek;
  //     const totalTime = this.player.duration();
  //     const percentageWatched = (timeWatched/totalTime * 100).toFixed(1);
  //     console.log(percentageWatched);
  //     if (parseFloat(percentageWatched) > 25) {
  //       if (!this.enableQuiz){
  //         this.service.videoTopicsEnable(this.topicid).then(() => {
  //         this.videoData();
  //       });

  //       this.enableQuiz = true;
  //       }
  //     }
  //   }
  // }

  private getToken(source, brow, callback) {
    this.service
      .getVideoToken(source, brow)
      .then((result) => {
        this.srcToken = result;
        callback(result);

        this.player.src([
          {
            src: result.src, //response.src,
            type: "application/vnd.ms-sstr+xml", //response.type,
            protectionInfo: [
              {
                type: result.protectionInfo.type,
                certificateUrl: result.protectionInfo.certificateUrl,
                authenticationToken: result.protectionInfo.authenticationToken,
              },
            ],
          },
        ]);
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  private sidebarQuiz(check, id) {
    if (check) {
      this.current(id);
      this.getVideoQuestions(id);
    } else {
      if (this.player)
        this.player.pause();
      this.$bvModal.show('quiz-locked')
    }
  }

  private current(id) {
    //debugger
    if (this.topicid === id && !this.firstTimeVideo) {
      return
    }

    this.sourceLoaded = false;


    if (this.player) {
      this.player.pause();
    }

    this.topicid = id;
    this.totalSeek = 0;

    if (this.firstTimeVideo) {
      this.firstTimeVideo = false;
    } else if (this.rating == 0) {
      this.$bvModal.show("rating");
    }
    this.ratingPrev = 0;
    this.ratingPrevId = this.currentTopicId;

    this.maxWatched = 0;
    this.currentTopicId = id;
    const entity = this.entities.find((e) => e.topicId === id);
    if (entity !== undefined) {
      this.source = entity.videoLink;


      this.$store.state.topicSelectName = entity.fullName;
      this.entity = entity;
      this.entity.description = config.renderHTML(this.entity.description);
      this.duration = 26;
      this.saveWatched();
      this.enableQuiz = entity.enableMcq;

      if (entity.videoLink.indexOf('<iframe') != -1) {
        this.iframeHtml = entity.videoLink;
        this.sourceLoaded = true;
      }
      else {
        this.iframeHtml = '';




        this.checkBrowser(entity.videoLink, (data) => {


          this.loadVideo();


        });



        this.videoData();

        this.chankStarted = false;
        this.actualW = 0;
        this.duration = 0;
      }

      this.service.getPGCtrating(id).then((response) => {
        this.rating = 0;
        if (response.data && response.data[0]) {
          this.rating = response.data[0].rating;
        }
      });
    }
  }

  private ampEventHandler(evt) {
    AppInsightsUtils.ampEventHandler4AppInsights(
      evt,
      this.player,
      this.$store.state.topicSelectName
    );
  }

  private registerEvents(amPlayer, ampEventHandler) {
    var events = [
      amp.eventName.loadstart,

      amp.eventName.durationchange,

      amp.eventName.loadeddata,

      amp.eventName.loadedmetadata,

      amp.eventName.canplaythrough,

      amp.eventName.waiting,

      amp.eventName.play,

      amp.eventName.playing,

      amp.eventName.ended,

      amp.eventName.seeking,

      amp.eventName.seeked,

      amp.eventName.pause,

      amp.eventName.fullscreenchange,

      amp.eventName.volumechange,

      amp.eventName.error,

      amp.eventName.timeupdate,

      amp.eventName.playbackbitratechanged,

      amp.eventName.downloadbitratechanged,
    ];
    for (let i = 0; i < events.length; i++) {
      this.player.addEventListener(events[i], ampEventHandler);
    }
  }

  private loadVideo() {
    let client = document.getElementById("main-content");
    if (client !== null) {
      this.player = amp("azuremediaplayer", {
        nativeControlsForTouch: false,
        logo: { enabled: false },
        autoplay: false,
        fluid: true,
        playbackSpeed: {
          enabled: true,
          initialSpeed: 1.0,
          speedLevels: [
            { name: "x4.0", value: 4.0 },
            { name: "x3.0", value: 3.0 },
            { name: "x2.0", value: 2.0 },
            { name: "x1.75", value: 1.75 },
            { name: "x1.5", value: 1.5 },
            { name: "x1.25", value: 1.25 },
            { name: "normal", value: 1.0 },
            { name: "x0.75", value: 0.75 },
            { name: "x0.5", value: 0.5 },
          ],
        },
        controls: true,
        width: "auto",
        height: 600,
        techOrder: [
          "azureHtml5JS",
          "flashSS",
          "html5FairPlayHLS",
          "silverlightSS",
          "html5",
        ],
      });
      this.player.addEventListener(amp.eventName.play, this.showTime);
      this.player.addEventListener(amp.eventName.pause, this.pauseTime);
      this.player.addEventListener(amp.eventName.seeked, this.seekingTime);
      this.player.addEventListener(amp.eventName.timeupdate, this.seekedTime);

      // let controlelement = document.getElementsByClassName('vjs-progress-control')[0];
      // controlelement.addEventListener("mouseover", this.progressClicked);
      // console.log(controlelement);

      this.player.addEventListener(amp.eventName.ended, this.videoCompleted);

      this.registerEvents(this.player, this.ampEventHandler);
    }
    // this.player.src([
    //   { type: "application/vnd.ms-sstr+xml", src: this.source },
    // ]);
    this.player.src([
      {
        src: this.srcToken.src, //response.src,
        type: this.srcToken.Type, //response.type,
        protectionInfo: [
          {
            type: this.srcToken.protectionInfo.type,
            certificateUrl: this.srcToken.protectionInfo.certificateUrl,
            authenticationToken:
              this.srcToken.protectionInfo.authenticationToken,
          },
        ],
      },
    ]);

    this.player.addEventListener("error", this.errorPlayback);
    this.totaltime = 0;
    clearInterval(this.timeInterval);
    this.timeInterval = setInterval(() => {
      if (this.totaltime == 0) {
        this.totaltime = Math.round(this.player.duration());

        if (this.totaltime > 0) {
          this.resetTimer(this.totaltime);
        }
      }

      if (this.totaltime > 0) {
        this.chunkTimer(this.player.currentTime());
      }

      // this.checkState();
    }, 1000);

    this.sourceLoaded = true;
  }

  playVideo() {
    if (this.player)
      this.player.play();

    this.$bvModal.hide('quiz-locked');
    this.$bvModal.hide('quiz-unlocked');
  }

  errorPlayback() {
    this.errorMessageVideo =
      "There was an issue in your playback, kindly check your internet connection. We will reload the video so you can seamlessly view it again.";

    this.lastTime = this.player.currentTime();
    this.startError = true;

    this.player.src([
      { type: "application/vnd.ms-sstr+xml", src: this.srcToken.src },
    ]);
  }

  private createChunks() {
    if (this.chankStarted == false && this.totaltime > 0) {
      this.chankParts = [];
      this.chankStarted = true;
      var oneChank = this.totaltime / this.totalChanks;

      for (var i = 0; i < this.totalChanks; i++) {
        this.chankParts.push({
          start: Math.round(oneChank * (i + 1) - oneChank),
          end: Math.round(oneChank * (i + 1)),
          watched: 0,
        });
      }

      this.chankStarted = true;
    }
  }

  private resetTimer(videoTime) {
    this.totaltime = Math.round(videoTime);

    if (this.chankStarted == false && this.totaltime > 0) {
      this.chankParts = [];
      this.chankStarted = true;
      var oneChank = this.totaltime / this.totalChanks;

      for (var i = 0; i < this.totalChanks; i++) {
        this.chankParts.push({
          start: Math.round(oneChank * (i + 1) - oneChank),
          end: Math.round(oneChank * (i + 1)),
          watched: 0,
        });
      }

      this.chankStarted = true;
    }
  }

  private prevTopic() {
    if (this.entities.indexOf(this.entity) > 0) {
      if (
        this.entities[this.entities.indexOf(this.entity) - 1].orderNumber === 0
      ) {
        this.paidMessage();
      } else {
        this.saveWatched();
        this.entity = this.entities[this.entities.indexOf(this.entity) - 1];
      }
    }
  }

  private nextTopic() {
    if (this.entities.indexOf(this.entity) < this.entities.length - 1) {
      if (
        this.entities[this.entities.indexOf(this.entity) + 1].orderNumber === 0
      ) {
        this.paidMessage();
      } else {
        this.saveWatched();
        this.entity = this.entities[this.entities.indexOf(this.entity) + 1];
      }
    }
  }

  private paidMessage() {
    // this.dialog.show<PayComponent>(PLATFORM.moduleName('app/backend/pay.component'));
  }

  private sumActual() {
    var realW = 0;
    for (var i = 0; i < this.parts.length; i++) {
      if (this.parts[i].vieved === true && this.parts[i].percentage > 0) {
        realW += this.parts[i].percentage;
      }
    }

    return realW;
  }

  private chunkTimer(timeToken) {
    this.duration = Math.round((Math.round(timeToken) * 100) / this.totaltime);
    this.actualW = timeToken;

    if (this.chankParts.length > 0) {
      var watche = 0;
      for (var i = 0; i < this.totalChanks; i++) {
        var start = this.chankParts[i].start;
        var end = this.chankParts[i].end;

        if (this.actualW >= start && this.actualW <= end) {
          var watchedChunk = timeToken - this.chankParts[i].start;
          this.chankParts[i].watched =
            Math.round((watchedChunk * 100) / this.chankParts[i].end) > 50
              ? 100
              : Math.round((watchedChunk * 100) / this.chankParts[i].end);
        }
        watche += this.chankParts[i].watched;
      }
      this.duration = Math.round(
        (watche / (this.chankParts.length * 100)) * 100
      );
    } else {
      this.createChunks();
    }
  }

  private saveWatched() {
    var topicsWatched: TopicsWatched = {
      topicWatchId: config.createGuid(),
      userId: this.auth.session.userId,
      topicId: this.entity.topicId,
      enableMcq: this.enableQuiz ?? false,
      operationOn: new Date(Date.now()),
      duration: this.actualW,
      percentage: this.duration >= 25 ? 100 : this.duration,
    };

    this.service.insertTopicWached(topicsWatched).catch((err) => {
      console.error(`Error: ${err.message}`);
    });
  }

  private askQuestion() {
    let data = {
      device_Id:
        this.auth.session.userName.split("@")[0] +
        window.navigator.userAgent.replace(/\D+/g, ""),
      application_Version: "1.4.8",
      Student_ID: this.auth.session.userName.split("@")[0],
      Teacher_ID: this.teacherID,
      Question: this.question,
      userMacAddress: "dsdd",
      Subject_ID: this.subjectID,
      Section_ID: this.classSection,
      From: this.teacherName,
      Topic: this.$store.state.chapterSelectName,
      application_Name: "HADAF",
    };

    if (this.sending == false) {
      this.sending = true;
      this.service.sendQuestion(data, false).then((response) => {
        this.sending = false;
        if (response.message.messageTypeId == "Success") {
          this.sentQuestion = true;
        } else {
          alert(
            "Your question could not be asked at this time. Please try again later"
          );
          throw response.message.messageTypeId;
        }
      });
    }
  }

  beforeDestroy() {
    try {
      if (this.player) {
        this.sendData();
        this.player.dispose();
      }
    } catch (e) {
      // player may not be initialized
    }
    clearInterval(this.timeInterval);
    this.saveWatched();
  }
}

interface Parts {
  percentage: number;
  vieved: boolean;
  css: string;
}

interface Chank {
  start: number;
  end: number;
  watched: number;
}
